import { render, staticRenderFns } from "./CreateNewDialog.vue?vue&type=template&id=3a3ce1aa&scoped=true"
import script from "./CreateNewDialog.vue?vue&type=script&lang=ts"
export * from "./CreateNewDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateNewDialog.vue?vue&type=style&index=0&id=3a3ce1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ce1aa",
  null
  
)

export default component.exports